<template>
  <v-row class="mx-1">
    <v-col cols="12">
      <v-row align="center" class="pr-4 mb-0 pb-0">
        <h4 class="mx-2">{{ $tc(partTranslationKey + '.self', 2) }}</h4>
        <v-spacer />
        <span class="text-secondary">{{ $t('contract.useValues') }}</span>
        <v-switch
          v-model="localIsMultiCurrency"
          @change="handleSetUseMultiCurrency"
          :disabled="disablePartsSwitch"
          :false-value=true
          :true-value=false
        />
        <span class="text-secondary">{{ $t('contract.usePercents') }}</span>
        <v-btn
          rounded
          color="success"
          x-small
          class="ml-3"
          @click="addPart"
          :disabled="localIsMultiCurrency ? false : !!form.parentContractId || partsSum === 100"
        >
          <v-icon> mdi-plus </v-icon>
          {{ $t(partTranslationKey + '.add') }}
        </v-btn>
        <InfoTooltip
          v-if="localIsMultiCurrency ? false : !!form.parentContractId || partsSum === 100"
          :text="$t(partTranslationKey + '.addActiveTooltip')"
        />
      </v-row>
      <p v-if="!!form.parentContractId" class="text--secondary">{{ $t('contract.partsDisabled') }}</p>
      <v-row v-if="partsErrorMessages" class="mx-1 mb-2 red--text">{{partsErrorMessages}}</v-row>
      <v-row
        v-for="(part, index) in form.parts"
        :key="index"
        align="baseline"
      >
        <PartForm
          :part="part"
          :index="index"
          :validationModel="validationModel.form.parts.$each[index]"
          :errorMessages="(field) => errorMessages(validationModel.form.parts.$each[index].name, field)"
          :form="form"
          :main-currency="mainCurrency"
          @remove="removePart"
          @calculate-rations="handleCalculateRations"
        />
      </v-row>
    </v-col>
  </v-row>
</template>

<script>
import { DEFAULT_PART } from '@/helpers'
import { getLocalizationContext } from '@/helpers/translations'

export default {
  name: 'PartsSection',
  props: ['form', 'currencies', 'validationModel', 'prices', 'errorMessages'],
  data () {
    return {
      localIsMultiCurrency: this.form.isMultiCurrency
    }
  },
  computed: {
    mainCurrency () {
      return this.form.currencies.find(i => i.value === 1)
    },
    disablePartsSwitch () {
      return this.form.parts.reduce((acc, curr) => acc || !!(isNaN(curr.currentPriceCents) ? curr.currentPriceCents.sum : curr.currentPriceCents), false)
    },
    partsErrorMessages () {
      return this.errorMessages(this.validationModel.form.parts, 'parts')[0]
    },
    partsSum () {
      return this.form.parts.reduce((acc, curr) => acc + Number(curr.ratio), 0)
    },
    partTranslationKey () {
      return getLocalizationContext(this.localIsMultiCurrency)
    }
  },
  methods: {
    addPart () {
      if (this.form.parts && this.form.parts.length) {
        const ratio = 100 - this.partsSum
        this.form.parts.push({
          ...DEFAULT_PART,
          ratio,
          currency: this.mainCurrency.key,
          signedPriceCents: this.form.isMultiCurrency ? 0 : this.form.signedPriceCents * (ratio / 100),
          contractor: { ...(this.form.contractor || {}) }
        })
      } else {
        this.form.parts = [{
          ...DEFAULT_PART,
          currency: this.mainCurrency.key,
          signedPriceCents: this.form.isMultiCurrency ? 0 : this.form.signedPriceCents,
          contractor: { ...(this.form.contractor || {}) }
        }]
      }
    },
    removePart (i) {
      this.form.parts.splice(i, 1)
    },
    handleSetUseMultiCurrency () {
      this.handleCalculateRations()
      this.$emit('setUseMultiCurrency')
    },
    handleCalculateRations () {
      if (this.form.isMultiCurrency) {
        this.$emit('calculate-percents')
      }
    }
  },
  watch: {
    'form.isMultiCurrency' (v, p) {
      this.localIsMultiCurrency = v
      if (!v && p) {
        this.form.parts.forEach(part => {
          const currency = this.form.currencies.find(i => i.key === part.currency) || { value: 1 }
          part.currency = this.mainCurrency.key
          part.signedPriceCents = part.signedPriceCents * currency.value
        })
        this.$emit('calculate-rations')
      }
    }
  }
}
</script>
